import Axios from 'axios';

const ALL_SEMESTERS = '/all_semester';
const ADD_SEMESTER = '/admin/create_semester';
const DELETE_SEMESTER = '/admin/delete_semester';

export default {
    getAll() {
        return Axios.get(ALL_SEMESTERS);
    },
    
    /**
    * @start: Unix timestamp
    **/
    addSemester(start) {
        return Axios.post(ADD_SEMESTER, {semester_start: start});
    },

    deleteSemester(id) {
        return Axios.post(DELETE_SEMESTER, {semester_is: id});
    }
}
